import actionTypes from 'SRC/modules/redux/actionTypes'

export const setVehicleParts = parts => ({
  type: actionTypes.SET_VEHICLE_PARTS,
  payload: parts
})
